module.exports = __webpack_public_path__ + "media/images/icon-map-location-22c102086831a3f8d1a613cf26716430.svg";